import {
  InputCheckboxListOption,
} from '../../../../../../types/interfaces/input.interface';
import { ColumnStepBase } from './column-step-base';

export class ColumnStepDevice extends ColumnStepBase {
  column: InputCheckboxListOption[] = [
    {value: 'device_eui', label: 'common.fields.device-eui', isTranslated: true},
    {value: 'serial_number', label: 'common.fields.serielNumber', isTranslated: true},
    {value: 'status', label: 'common.fields.status', isTranslated: true},
    {value: 'manufacturer', label: 'common.fields.manufacturer', isTranslated: true},
    {value: 'model', label: 'common.fields.model', isTranslated: true},
    {value: 'address', label: 'common.fields.address', isTranslated: true},
    {value: 'latitude', label: 'common.fields.latitude', isTranslated: true},
    {value: 'longitude', label: 'common.fields.longitude', isTranslated: true},
    {value: 'comment', label: 'common.fields.comment', isTranslated: true},
    {value: 'metadata', label: 'common.fields.metadata', isTranslated: true},
    {value: 'last_measurement', label: 'common.fields.last-measurement', isTranslated: true},
    {value: 'last_activity', label: 'common.fields.last-activity', isTranslated: true},
    {value: 'last_sigi_send', label: 'common.fields.last-sigi-send', isTranslated: true},
    {value: 'updated_at', label: 'common.fields.updated-at', isTranslated: true},
    {value: 'created_at', label: 'common.fields.created-at', isTranslated: true},
  ];

  constructor() {
    super([
      'device_eui',
      'serial_number',
      'status',
      'model',
      'address',
      'last_measurement',
      'last_activity',
    ]);
  }
}
